import { DocumentNode, gql } from "@apollo/client";
import _ from "lodash";

export interface QuantityScaleItem {
  quantity: number;
  price: number;
}

export interface MutationHelper {
  create: DocumentNode;
  update: DocumentNode;
  delete: DocumentNode;
}

export type QuantityScale = Array<QuantityScaleItem>;

type RecordKey<X extends string, Y extends string> = `${Y}${Capitalize<X>}`;

export type GenericCreateResponse<X extends string> = Record<
  RecordKey<X, "create">,
  { id: number }
>;

/*
{
  "create$X": { id: number }
}
*/

export type GenericUpdateResponse<X extends string> = Record<
  RecordKey<X, "update">,
  { id: number }
>;

export type GenericDeleteResponse<X extends string> = Record<
  RecordKey<X, "delete">,
  { success: boolean }
>;

export const GenericCreateMutation = (
  x: string
) => gql`mutation create${_.capitalize(x)}($values: Create${_.capitalize(
  x
)}Input!) {
  create${_.capitalize(x)}(values: $values) {
    id
  }
}`;

export const GenericUpdateMutation = (
  x: string
) => gql`mutation update${_.capitalize(x)}($values: Update${_.capitalize(
  x
)}Input!) {
  update${_.capitalize(x)}(values: $values) {
    id
  }
}`;

export const GenericDeleteMutation = (
  x: string
) => gql`mutation delete${_.capitalize(x)}($id: ID!) {
  delete${_.capitalize(x)}(id: $id)
}`;

export const GraphQLHelper = (x: string): MutationHelper => ({
  create: GenericCreateMutation(x),
  update: GenericUpdateMutation(x),
  delete: GenericDeleteMutation(x),
});
